import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useAuth } from "../../../../../../contexts/auth-context";
import { auth } from "../../../../../../utils/firebase-config";
import { useAlert } from "../../../../../../contexts/alert-context";
import CTAInfoComponent from "../../../../../../components/CTAInfoComponent/CTAInfoComponent";
import { SparkIcon } from "@bosch-web-dds/spark-ui-react";
import { ConditionPayDTO } from "./condition-pay-DTO";
import { addNewConditionPay, getConditionPay } from "../../../../scrap-generator-service";

const ConditionPay: React.FC<{ enabledUsers: string[] }> = ({
  enabledUsers,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userDoc } = useAuth();
  const profile = userDoc?.profile;
  const { id } = useParams<{ id: string }>();
  const { setAlert } = useAlert();
  const [userId, setUserId] = useState<string>();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId("");
      }
    });
    return () => unsubscribe();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ConditionPayDTO>();

  useEffect(() => {
    if (id) {
      getConditionPay(id).then((data) => {
        if (data) {
          Object.entries(data).forEach(([key, value]) => {
            if (typeof value === "object" && value !== null) {
              Object.entries(value as Record<string, unknown>).forEach(
                ([subKey, subValue]) => {
                  setValue(
                    `${key}.${subKey}` as keyof ConditionPayDTO,
                    subValue as any
                  );
                  setValue(
                    "value",
                    data.value ? data?.value?.toString() : ""
                  );
                }
              );
            } else {
              setValue(key as keyof ConditionPayDTO, value as any);
            }
          });
        }
      });
    }
  }, [id, setValue]);

  const onSubmit = async (pay: ConditionPayDTO) => {
      try {
        if (id) {
          await addNewConditionPay(pay, id ?? "");
          setAlert({ text: t("alert-successfully-registered"), type: "success" });
        
        }
      } catch (e) {
        console.error("Erro ao cadastrar: ", e);
        setAlert({ text: `${t("alert-error-registered")}:`, type: "error" });
      }
    };
  
  

  if (enabledUsers.includes(profile || "public")) {
    return (
      <div className="page-centered">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-fields flex-column" style={{display:"flex",flexDirection:"row", marginTop:"70px"}}>
            <br />
            <div  style={{marginTop:"5px"}}>
                <label><h3>Condições de pagamento:</h3></label>
            </div>
            <div className="flex-row">
              <div className="flex-column" style={{ alignItems: "center" }}>
                <textarea
                  placeholder={t("placeholder.generalEmpty")}
                  id="legalName"
                  style={{minHeight:"15rem", minWidth:"40rem"}}
                  {...register("value", { required: true })}
                />
                {errors.value && (
                  <span>{t("error-input-required")}</span>
                )}
              </div>
              <h2 style={{ alignItems: "center" }}></h2>
            </div>
          </div>
          <br />
          <br />
          <div className="flex-row buttons-section">
            <button className="blue" type="submit">
              {t("label-save")}
            </button>
          </div>
        </form>
      </div>
    );
  } else {
    navigate("/page-not-found");
    return <></>;
  }
};

export default ConditionPay;
